// extracted by mini-css-extract-plugin
export default {"projectList":"projectList__nkxvNw","label":"label__ljZolf","projectChosen":"projectChosen__hMpZBW","projectDragIcon":"projectDragIcon__fPk1FO"};